import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { FunctionDto, AccountableFunctionDto } from '@cradua/data';
import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'app-accountablefunction-container',
  templateUrl: './accountablefunction-container.component.html',
  styleUrls: ['./accountablefunction-container.component.scss'],
})
export class AccountablefunctionContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  functions$: Observable<FunctionDto[]>;
  accountableFunctions$: Observable<AccountableFunctionDto[]>;
  loading: boolean;
  isLoadingFunction$: Observable<boolean>;
  isLoadingAccountableFunction$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingFunction$ = this.gatwayFacade.isLoadingGateway('Function');
    this.isLoadingAccountableFunction$ = this.gatwayFacade.isLoadingGateway(
      'AccountableFunction'
    );

    this.accountableFunctions$ = this.gatwayFacade.loadGateway(
      'AccountableFunction'
    );
    this.functions$ = this.gatwayFacade.loadGateway('Function');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteAccountableFunction(deletedValue: any) {
    this.gatwayFacade.remove('AccountableFunction', deletedValue);
  }

  // this method control both the create and update
  onSubmitAccountableFunction(formValue: any) {
    console.log('container', formValue);
    const pullData = formValue.AccountableFunctions;

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllAccountableFunction = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id) {
        allUpdates.push(pullData[i]);
      } else {
        addAllAccountableFunction.push(pullData[i]);
      }
    }

    // check if the addAllAccountableFunction array is not empty, then dispatch the data to the store
    if (addAllAccountableFunction.length > 0) {
      this.gatwayFacade.add('AccountableFunction', addAllAccountableFunction);
    }

    // dispatch update data to the store
    if (allUpdates.length > 0) {
      this.gatwayFacade.update('AccountableFunction', allUpdates, ['id']);
    }
  }
}
